var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAudioSmall(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_25604",
    "data-name": "Group 25604",
    transform: "translate(-336 -1229)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25603",
    "data-name": "Group 25603"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25598",
    "data-name": "Group 25598",
    transform: "translate(-7 192)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path",
    d: "M24,0H3A3.009,3.009,0,0,0,0,3V24a3.009,3.009,0,0,0,3,3H24a3.009,3.009,0,0,0,3-3V3A3.009,3.009,0,0,0,24,0Z",
    transform: "translate(348 1041)",
    fill: "#75aad3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "M15.077,19.686a.787.787,0,0,1-.8-.771v-.17a.782.782,0,0,1,.533-.723,6.162,6.162,0,0,0,2.816-2.153,5.732,5.732,0,0,0,0-6.741,6.162,6.162,0,0,0-2.816-2.153.789.789,0,0,1-.533-.723v-.17a.794.794,0,0,1,1.076-.723,7.932,7.932,0,0,1,3.7,2.757,7.373,7.373,0,0,1,0,8.764,7.932,7.932,0,0,1-3.7,2.757A.807.807,0,0,1,15.077,19.686ZM11.6,18.094h0a.9.9,0,0,1-.621-.25l-2.924-2.8H5.389A.871.871,0,0,1,4.5,14.2V10.8a.871.871,0,0,1,.889-.85H8.056l2.924-2.8A.9.9,0,0,1,11.6,6.9a.945.945,0,0,1,.621.234.819.819,0,0,1,.278.619v9.493a.819.819,0,0,1-.278.619A.945.945,0,0,1,11.6,18.094Zm2.677-2.179h0V9.074A3.8,3.8,0,0,1,16.5,12.5a3.674,3.674,0,0,1-.618,2.04,3.939,3.939,0,0,1-1.6,1.376Z",
    transform: "translate(349.5 1042.691)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    width: 36,
    height: 36,
    transform: "translate(336 1229)",
    fill: "none"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAudioSmall);
export default __webpack_public_path__ + "static/media/audio-small.9cff48e79e808c4a591221fe780d794e.svg";
export { ForwardRef as ReactComponent };